
export default {
	contactList: state => state.contactIds.map(id => state.contacts[id]),
}